import { getActivityModuleIds } from "../../common/activity/activity";

export default {
    computed: {
        admin() {
            return this.activity && this.activity.charge_status == 1
        },
        editable() {
            const admin = this.admin; // 是否是超管
            const activity = this.activity;
            const moduleKey = this.moduleKey; // 功能模块id
            let res = admin;
            // 是否可编辑判断： 超管或者是否是对应模块的组长或组员
            if(!res && activity && moduleKey) {
                const ids = getActivityModuleIds(activity);
                res = ids.indexOf(moduleKey) >= 0;
            }
            return res;
        },
    }
}
